import Logo from "../../assets/images/Group.png";
import BodyPic from "../../assets/images/Pic.png";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { LoginSchema } from "../../lib/zodForValidation";
import { useDispatch } from "react-redux";
import { loginUser } from "../../redux/apicalls/authApiCall";

function Login() {
  const navigate = useNavigate()
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(LoginSchema),
  });

  const onSubmit = async (data) => {
    const loginReqData = {
      ...data,
      device_name: "Oppo A15",
    };

    await dispatch(loginUser(loginReqData));

    localStorage.setItem("userName", data.email);

    const loggedUser = JSON.parse(localStorage.getItem("userInfo"));

    if (loggedUser?.user_type === "stuff") {
      navigate("/otp", {
        state: {
          otp: loggedUser?.otp,
          user_id: loggedUser?.user_id,
        },
      });
    } else {
      navigate("/orders");
    }
  };

  return (
    <div class="row  ">
      <div class="col-md-7 col-xs-12 col-sm-12 col-lg-5 sideForImg">
        <div className="header bg-black rounded-3 border-end border-3 border-black">
          <div className="logoHeader">
            <img className="loginLogo" src={Logo} alt="Logo" />
            <p className=" mainText">
              Login to manage orders and imporove efficiency
            </p>
          </div>
          <img className=" mainImg" src={BodyPic} alt="Car Imges" />
        </div>
      </div>
      <div class="col-md-5 col-sm-12 col-xs-12 col-lg-7 p-0 ps-2 pe-4 sideForinfo">
        <div className=" welcom">
          <form onSubmit={handleSubmit(onSubmit)} className="w-100">
            <h1 className="title">Welcome back</h1>
            <p className="welcomeP">Glad to see you again</p>
            <div class="mb-4 inpForm">
              <label for="exampleFormControlInput1" class="form-label label">
                Email OR Username
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="name@example.com"
                {...register("email")}
              />
              {errors.email && (
                <p className="danger">{`${errors.email.message}`}</p>
              )}
            </div>
            <div class="mb-4 inpForm">
              <label for="exampleFormControlInput1" class="form-label label">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter your password"
                {...register("password")}
              />
              {errors.password && (
                <p className="danger">{`${errors.password.message}`}</p>
              )}
            </div>
            <div className=" rememberTheName">
              <div>
                <input type="checkbox" className="px-3 d-inline" />
                <span className="rememberMe">Remember me</span>
              </div>
              <Link to="/">
                <p>Forgot password?</p>
              </Link>
            </div>
            <div className=" w-75 mx-auto">
              <button
                type="submit"
                className="btn btn-dark submetButton"
                disabled={isSubmitting}
              >
                Login
              </button>
            </div>
          </form>
        </div>
        <div className="noAccount">
          Don't have an account?
          <Link to="/registration">
            <span className="register">Register</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
